import axios from 'axios';
import "../Sys/config.js";

var apiUrl = global.platformURI;
export class SkillsAndTransformation {
    constructor() {
        axios.interceptors.request.use(function (config) {
            let token = localStorage.getItem('ssoToken');
            config.baseURL = apiUrl;
            config.headers.Authorization = `Token ${token}`;
            return config;
        }, error => {
            console.log('error.response.status', error);
            return error;
        });
    }

    // Course catalogue
    getCourseCatalogue() {
        return axios.get("project/coursecatalog")
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    getLearningHub(params = {}) {
        const query = new URLSearchParams();
        Object.entries(params || {}).forEach(([key, value]) => {
            if (value === undefined || value === null || value === '' || value === false) {
                return;
            }
            query.set(key, String(value));
        });
        const qs = query.toString();
        return axios.get(`project/learninghub${qs ? `?${qs}` : ''}`)
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    enrollLearningHubCourse(uuid) {
        return axios.post(`project/learninghub/${uuid}/enroll`)
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    launchLearningHubCourse(uuid) {
        return axios.get(`project/learninghub/${uuid}/launch`)
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    requestLearningHubAccess(courseId) {
        return axios.post('project/learninghub/requests', { course_id: courseId })
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    submitLearningHubUpgrade(payload) {
        return axios.post('project/learninghub/requests', payload)
            .then((res) => ({ ...(res.data || {}), httpStatus: res.status }))
            .catch((err) => {
                const data = err.response && err.response.data;
                const body = data && typeof data === 'object' && !Array.isArray(data)
                    ? data
                    : { message: 'Unable to submit the Learning Hub request' };
                return { ...body, httpStatus: err.response ? err.response.status : 0 };
            });
    }

    getLearningHubRequests(status) {
        const params = {};
        if (status) params.status = status;
        return axios.get('project/learninghub/requests', { params })
            .then((res) => ({ ...(res.data || {}), httpStatus: res.status }))
            .catch((err) => {
                const data = err.response && err.response.data;
                const body = data && typeof data === 'object' && !Array.isArray(data)
                    ? data
                    : { message: 'Unable to load Learning Hub upgrade requests' };
                return { ...body, httpStatus: err.response ? err.response.status : 0 };
            });
    }

    reviewLearningHubRequest(requestId, payload) {
        return axios.patch(`project/learninghub/requests/${requestId}`, payload)
            .then((res) => ({ ...(res.data || {}), httpStatus: res.status }))
            .catch((err) => {
                const data = err.response && err.response.data;
                const body = data && typeof data === 'object' && !Array.isArray(data)
                    ? data
                    : { message: 'Unable to update the Learning Hub request' };
                return { ...body, httpStatus: err.response ? err.response.status : 0 };
            });
    }

    getEnrolledLearningHubCourses() {
        return axios.get("project/learninghub/enrolled")
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    // Register courses
    getRegisterCourse(filter) {
        return axios.get(`project/registeredcourses${filter ? '?category=' + filter : ''}`)
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    // Register apprenticeship
    getRegisteredApprenticeships() {
        return axios.get("project/registeredapprenticeships/?")
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    // Register Assessments
    getRegisteredassessments() {
        return axios.get("project/registeredassessments/?")
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    sendCourseRequest(payload) {
        return axios.post("main/courserequest/", payload)
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    getCourseCompletionGraph() {
        return axios.get("main/courselicenceuser/")
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

    getBestCourses() {
        return axios.get('main/popularcoursegraph')
            .then(res => res.data)
            .catch(err => (err.response && err.response.data) ? err.response.data : err);
    }

}
